/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trim whole result`)
};

const es_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recortar resultado completo`)
};

const de_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamtes Ergebnis trimmen`)
};

const nl_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heel resultaat bijsnijden`)
};

const fr_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les espaces du résultat`)
};

const it_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taglia l'intero risultato`)
};

const pt_br2_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparar resultado inteiro`)
};

const pt_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparar resultado completo`)
};

const ja_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全体結果をトリム`)
};

const zh_wsc_trim_result = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修剪整个结果`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_trim_result = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_trim_result(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_trim_result", locale)
	if (locale === "en") return en_wsc_trim_result(inputs)
	if (locale === "es") return es_wsc_trim_result(inputs)
	if (locale === "de") return de_wsc_trim_result(inputs)
	if (locale === "nl") return nl_wsc_trim_result(inputs)
	if (locale === "fr") return fr_wsc_trim_result(inputs)
	if (locale === "it") return it_wsc_trim_result(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_trim_result(inputs)
	if (locale === "pt") return pt_wsc_trim_result(inputs)
	if (locale === "ja") return ja_wsc_trim_result(inputs)
	return zh_wsc_trim_result(inputs)
};